import React, {useState} from 'react';
import { useForm, Controller } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { connect } from 'react-redux';
import {Actions as ACTIONS} from '../../store/actions/payrollActions';
import { format } from 'date-fns'
import { InboxArrowDownIcon } from "@/icons/outline";

import Spinner from '../common/Spinner';
import { XMarkIcon } from '@heroicons/react/20/solid'

import cleanDeep from "clean-deep";

const TestInLiveModal = ({
  salary,
  sendPayslips,
  closeModal,
  modalStatus,
  payslipCount,
  sending,
  sent,
  generateRTISubmissions,
  openTestConfirmationModal
}) => {
  const [attachPdf, setAttachPdf] = useState(false);

  const { register, handleSubmit, control, watch, setValue, reset } = useForm();

  if (!modalStatus){
    return null
  }

  return (
    <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{display: "block",background: "rgba(0,0,0,0.4)"}}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="block block-themed block-transparent remove-margin-b" style={{padding: 0}}>
            <div className="block-header bg-primary-dark">
              <ul className="block-options">
                <li>
                  <button data-dismiss="modal" type="button" onClick={closeModal}>
                    <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                  </button>
                </li>
              </ul>
              <h3 className="block-title" style={{padding:"15px 20px"}}>
                Method of Submission
              </h3>
            </div>
            <div className="modal-body">
              <div className="clearfix"></div>
              Would you like to submit a live submission or a test submission?
            </div>
            <div className="block-content" style={{padding: "0px 20px 1px"}}>
              {
                  sending && 
                  <Spinner 
                     style={{width: '2rem',height: '2rem', verticalAlign: 'middle',marginTop: 20}}
                     className="animate-spin -ml-1 mr-3 h-5 w-5 text-success right"/>
              }

              <div className="flex-auto buttons" style={{paddingBottom: 20}}>
                {
                  !sent && 
                  <button className="btn btn-success pull-right" type="submit" 
                    onClick={() =>  {
                        generateRTISubmissions({test:true});
                        closeModal();
                    }
                  }
                  >
                    <InboxArrowDownIcon className="w-7 h-7 mr-3" style={{verticalAlign: "text-bottom"}}/>
                    Test Submission
                  </button>
                }
                {
                  sent && 
                  <div className="btn btn-success pull-right">
                    Test submission sent successfully
                  </div>
                }
                {
                  <button className="btn btn-success pull-left" type="submit"
                    onClick={() => {
                        generateRTISubmissions();
                        openTestConfirmationModal();
                        closeModal();
                    }}
                  >
                    <InboxArrowDownIcon className="w-7 h-7 mr-3" style={{verticalAlign: "text-bottom"}}/>
                    Live Submission
                  </button>
                }
                {
                  sent && 
                  <div className="btn btn-success pull-left">
                    Live submission sent successfully
                  </div>
                }
                <div className="clearfix"></div>
              </div>
            </div>
            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {

  const { employees } = state.payroll;
  const {sendPayslipModal} = state

  return {
    modalStatus: state.payroll.testInLiveModal,
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeModal: () => dispatch(ACTIONS.setTestInLiveModal(false)),
  generateRTISubmissions: () => dispatch(ACTIONS.generateRTISubmissions()),
  openTestConfirmationModal: () => dispatch(ACTIONS.setTestConfirmationModal(true))
});

export default connect(mapStateToProps, mapDispatchToProps)(TestInLiveModal);
